'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var envs = exports.envs = ['demo', 'development', 'production'];

var getEnv = exports.getEnv = function getEnv() {
  var env = process.env.REACT_APP_ENV || process.env.NODE_ENV || 'development';
  return envs.includes(env) ? env : 'development';
};

var getEnvData = exports.getEnvData = function getEnvData(attribute) {
  var value = process.env['REACT_APP_' + attribute] || process.env[attribute] || null;
  return value;
};